(() => {
  'use strict';
  const root = document.getElementById('av-grounding-v01');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  let data = {};
  try { data = JSON.parse(document.getElementById('av-product-data')?.textContent || '{}'); } catch {}
  const variants = Array.isArray(data.variants) ? data.variants : [];
  const euSets = [1, 2, 3].map(n => variants.find(v => v.options?.[0] === 'EU' && v.options?.[1] === (n === 1 ? '1 Tuch' : n + ' Tücher')));
  const money = n => new Intl.NumberFormat('de-DE', {style: 'currency', currency: data.currency || 'EUR'}).format(n / 100);
  const liveCart = data.liveCart === true;
  const shopRoot = (data.root || '/').replace(/\/?$/, '/');
  const motion = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  let lastFocus;
  function openDialog(d) { lastFocus = document.activeElement; if (!d.open) d.showModal(); document.body.style.overflow = 'hidden'; }
  function closeDialog(d) { d.close(); document.body.style.overflow = ''; lastFocus?.focus(); }
  $$('dialog').forEach(d => {
    d.addEventListener('cancel', () => {document.body.style.overflow = ''; lastFocus?.focus();});
    d.addEventListener('click', e => {if (e.target === d) {const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);}});
  });
  const productImages = $$('[data-av-image]');
  let productImageIndex = 0;
  function showProductImage(index) {
    if (!productImages.length) return;
    productImageIndex = (index + productImages.length) % productImages.length;
    const b = productImages[productImageIndex], image = $('[data-av-main-image]');
    image.src = b.dataset.avImage; image.alt = b.dataset.avAlt;
    productImages.forEach(e => e.setAttribute('aria-pressed', String(e === b)));
    const count = $('[data-av-product-count]');
    if (count) count.textContent = (productImageIndex + 1) + ' / ' + productImages.length;
    const thumbs = $('.av-thumbs');
    if (matchMedia('(max-width:1100px)').matches) thumbs.scrollTo({left: b.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - b.clientWidth)/2, behavior: motion});
    else thumbs.scrollTo({top: b.offsetTop - thumbs.offsetTop - (thumbs.clientHeight - b.clientHeight)/2, behavior: motion});
  }
  productImages.forEach((b, i) => {
    b.addEventListener('click', () => showProductImage(i));
    b.addEventListener('keydown', e => {if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {e.preventDefault(); showProductImage(i + (e.key === 'ArrowRight' ? 1 : -1)); productImages[productImageIndex].focus({preventScroll:true});}});
  });
  $('[data-av-product-prev]')?.addEventListener('click', () => showProductImage(productImageIndex - 1));
  $('[data-av-product-next]')?.addEventListener('click', () => showProductImage(productImageIndex + 1));
  function tab(name, scroll = false) {
    $$('[data-av-tab]').forEach(b => {const on = b.dataset.avTab === name; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1;});
    $$('[data-av-panel]').forEach(d => d.open = d.dataset.avPanel === name);
    if (scroll) $('.av-details').scrollIntoView({behavior: motion, block: 'start'});
  }
  $$('[data-av-tab]').forEach((b, i) => {
    b.tabIndex = i ? -1 : 0;
    b.addEventListener('click', () => tab(b.dataset.avTab));
    b.addEventListener('keydown', e => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault(); const a = $$('[data-av-tab]'), n = e.key === 'Home' ? 0 : e.key === 'End' ? a.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + a.length) % a.length;
      tab(a[n].dataset.avTab); a[n].focus();
    });
  });
  matchMedia('(max-width:749px)').addEventListener('change', e => {if (!e.matches) tab($('[data-av-tab][aria-selected="true"]').dataset.avTab);});
  $$('[data-av-open-detail]').forEach(b => b.addEventListener('click', () => tab(b.dataset.avOpenDetail, true)));
  let benefits = [], benefit = 0;
  try {benefits = JSON.parse($('#av-benefit-data').textContent);} catch {}
  function showBenefit(n) {
    if (!benefits.length) return;
    benefit = (n + benefits.length) % benefits.length;
    const current = benefits[benefit];
    $('[data-av-benefit-title]').textContent = current.title;
    $('[data-av-benefit-copy]').textContent = current.summary;
    const image = $('[data-av-benefit-image]'); image.src = current.image; image.alt = 'Avenlo – ' + current.title;
    $('[data-av-benefit-count]').textContent = (benefit + 1) + ' / ' + benefits.length;
    $$('[data-av-benefit]').forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.avBenefit === benefit)));
  }
  $$('[data-av-benefit]').forEach(b => {
    b.addEventListener('click', () => showBenefit(+b.dataset.avBenefit));
    b.addEventListener('keydown', e => {if (['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) {e.preventDefault(); showBenefit(e.key === 'Home' ? 0 : e.key === 'End' ? benefits.length - 1 : benefit + (e.key === 'ArrowRight' ? 1 : -1)); $$('[data-av-benefit]')[benefit].focus();}});
  });
  $('[data-av-benefit-prev]').addEventListener('click', () => showBenefit(benefit - 1));
  $('[data-av-benefit-next]').addEventListener('click', () => showBenefit(benefit + 1));
  const community = $('[data-av-community]');
  function moveCommunity(direction) {community.scrollBy({left: direction * (community.firstElementChild.getBoundingClientRect().width + 24), behavior: motion});}
  $('[data-av-community-prev]').addEventListener('click', () => moveCommunity(-1));
  $('[data-av-community-next]').addEventListener('click', () => moveCommunity(1));
  const reviewRows = $$('[data-av-review-topic]');
  let reviewLimit = 5;
  function updateReviews(reset = true) {
    if (reset) reviewLimit = 5;
    const filter = $('[data-av-review-filter]').value, sort = $('[data-av-review-sort]').value;
    const rating = $('input[name="av-review-rating"]:checked').value;
    const sorted = [...reviewRows].sort((a,b) => {
      if (sort === 'name') return a.dataset.avReviewName.localeCompare(b.dataset.avReviewName, 'de');
      if (sort === 'newest' || sort === 'oldest') return a.dataset.avReviewDate.localeCompare(b.dataset.avReviewDate) * (sort === 'newest' ? -1 : 1);
      if (sort === 'highest' || sort === 'lowest') return (+a.dataset.avReviewRating - +b.dataset.avReviewRating) * (sort === 'highest' ? -1 : 1) || +a.dataset.avReviewIndex - +b.dataset.avReviewIndex;
      return +a.dataset.avReviewIndex - +b.dataset.avReviewIndex;
    });
    let count = 0;
    sorted.forEach(row => {
      const matches = (filter === 'all' || row.dataset.avReviewTopic === filter) && (rating === 'all' || row.dataset.avReviewRating === rating);
      if (matches) count++;
      row.hidden = !matches || count > reviewLimit;
      $('[data-av-review-list]').append(row);
    });
    $('[data-av-review-count]').textContent = Math.min(count,reviewLimit) + ' von ' + count + (count === 1 ? ' Erfahrungsbericht' : ' Erfahrungsberichten');
    $('[data-av-review-more]').hidden = count <= reviewLimit;
    $('[data-av-review-more]').textContent = Math.min(5,count-reviewLimit) + ' weitere Erfahrungen anzeigen';
    $('[data-av-review-empty]').hidden = count > 0;
  }
  $('[data-av-review-more]').addEventListener('click', () => {reviewLimit += 5; updateReviews(false);});
  $('[data-av-filter-toggle]').addEventListener('click', () => {
    const panel = $('#av-review-filters'), open = panel.hidden;
    panel.hidden = !open;
    $('[data-av-filter-toggle]').setAttribute('aria-expanded', String(open));
  });
  $('[data-av-review-filter]').addEventListener('change', updateReviews);
  $('[data-av-review-sort]').addEventListener('change', updateReviews);
  $$('input[name="av-review-rating"]').forEach(input => input.addEventListener('change', updateReviews));
  $('[data-av-filter-reset]').addEventListener('click', () => {
    $('[data-av-review-filter]').value = 'all';
    $('input[name="av-review-rating"][value="all"]').checked = true;
    $('[data-av-review-sort]').value = 'source'; updateReviews();
  });
  // The installed Mojo offer owns the radio controls and the cart request.
  // Each tier is one complete Shopify EU set, always at quantity 1.
  const form = $('#av-product-form');
  const addButton = form?.querySelector('[data-av-add]');
  const message = $('[data-av-message]');
  const offerSelector = '.mojo-sf[data-offer-id="cmuon820y0v6yobkpp4ms4l95"]';
  let mojoReady = false;
  const setText = (element, text) => {if (element && element.textContent !== text) element.textContent = text;};
  function syncMojo() {
    const offer = $(offerSelector);
    const tiers = offer ? [...offer.querySelectorAll('[data-mojo-tier]')] : [];
    let valid = liveCart && tiers.length === 3 && euSets.every(Boolean);
    tiers.forEach(tier => {
      const v = euSets[Number(tier.dataset.tierIndex)];
      const picker = tier.querySelector('[data-mojo-vp]');
      if (!v || !picker || tier.dataset.tierQty !== '1') {valid = false; return;}
      const selects = [...picker.querySelectorAll('[data-mojo-vp-select]')];
      if (selects.length !== 2) {valid = false; return;}
      selects.forEach(select => {
        const option = select.dataset.optionName === 'Anschluss' ? v.options[0] : select.dataset.optionName === 'Set' ? v.options[1] : null;
        if (!option || ![...select.options].some(o => o.value === option)) {valid = false; return;}
        // Keep Mojo's real variant picker for its atomic cart operation, but
        // disallow switching a named set to another size or a UK connection.
        select.value = option;
        [...select.options].forEach(o => {if (o.value !== option) o.remove();});
      });
      // Mojo skips hidden pickers when pricing inactive tiers. Display each
      // complete set's actual Shopify price without adding another discount.
      setText(tier.querySelector('.mojo-sf-tier-price-current'), money(v.price));
      const comparison = tier.querySelector('.mojo-sf-tier-price-compare');
      setText(comparison, v.compare_at_price > v.price ? money(v.compare_at_price) : '');
    });
    const selected = tiers.find(tier => tier.getAttribute('aria-checked') === 'true');
    const v = selected ? euSets[Number(selected.dataset.tierIndex)] : null;
    mojoReady = Boolean(valid && v && v.available !== false);
    if (addButton && !addButton.classList.contains('mojo-sf-atc-busy')) addButton.disabled = !mojoReady;
    if (mojoReady) {
      const input = form.querySelector('[name="id"]');
      if (input.value !== String(v.id)) input.value = String(v.id);
      form.querySelector('[name="quantity"]').value = '1';
      setText(message, '');
    }
    root.classList.toggle('av-mojo-active', mojoReady);
  }
  form?.addEventListener('submit', event => {
    if (!mojoReady) {
      event.preventDefault();
      setText(message, liveCart ? 'Die Setauswahl lädt noch. Bitte versuche es gleich erneut.' : 'Die Setauswahl ist im Avenlo-Onlineshop verfügbar.');
    }
  });
  $('[data-av-select-set]')?.addEventListener('click', () => {
    const target = $(offerSelector) || $('#av-buy');
    target.scrollIntoView({behavior: motion, block: 'center'});
    target.querySelector('[data-mojo-tier][aria-checked="true"]')?.focus({preventScroll:true});
  });
  $('[data-av-cart-open]').addEventListener('click', () => {
    if (liveCart) location.assign(shopRoot + 'cart');
    else setText(message, 'Der Shopify-Warenkorb ist im Avenlo-Onlineshop verfügbar.');
  });
  $$('[data-av-count]').forEach(e => e.hidden = true);
  // This product layout has no cart drawer. Open Shopify's cart only after
  // Mojo reports its successful cart refresh, preserving all Mojo properties.
  document.addEventListener('cart:update', event => {
    if (liveCart && event.detail?.source === 'mojo') location.assign(shopRoot + 'cart');
  });
  new MutationObserver(syncMojo).observe($('.av-purchase'), {childList:true,subtree:true,attributes:true,attributeFilter:['aria-checked','hidden']});
  syncMojo();
  if (!liveCart) setText(message, 'Die Setauswahl ist im Avenlo-Onlineshop verfügbar.');
  $('[data-av-menu]').addEventListener('click', () => {const open = $('.av-nav').classList.toggle('av-open'); $('[data-av-menu]').setAttribute('aria-expanded',String(open));});
  $$('.av-nav a').forEach(a => a.addEventListener('click', () => {$('.av-nav').classList.remove('av-open'); $('[data-av-menu]').setAttribute('aria-expanded','false');}));
  $('[data-av-top]').addEventListener('click', () => window.scrollTo({top:0,behavior:motion}));
  function onScroll() {const show = $('[data-av-add]').getBoundingClientRect().bottom < 0; $('[data-av-sticky]').classList.toggle('av-visible',show); $('[data-av-top]').classList.toggle('av-visible',scrollY>700);}
  window.addEventListener('scroll',onScroll,{passive:true});
  $('[data-av-evidence-open]').addEventListener('click', () => openDialog($('[data-av-evidence-modal]')));
  $('[data-av-evidence-close]').addEventListener('click', () => closeDialog($('[data-av-evidence-modal]')));
  $('[data-av-evidence-how]').addEventListener('click', () => closeDialog($('[data-av-evidence-modal]')));
  const mediaItems = [...new Map($$('[data-av-review-image]').map(b => [b.dataset.avReviewImage,{src:b.dataset.avReviewImage,caption:b.dataset.avReviewAlt}])).values()];
  let mediaIndex = 0;
  function showMedia(index) {
    mediaIndex=(index+mediaItems.length)%mediaItems.length;
    const item=mediaItems[mediaIndex];
    $('[data-av-media-image]').src=item.src;
    $('[data-av-media-image]').alt=item.caption;
    $('[data-av-media-caption]').textContent=item.caption;
    $('[data-av-media-count]').textContent=(mediaIndex+1)+' / '+mediaItems.length;
  }
  $$('[data-av-review-image]').forEach(b => b.addEventListener('click', () => {
    showMedia(mediaItems.findIndex(item=>item.src===b.dataset.avReviewImage));
    openDialog($('[data-av-media-modal]'));
  }));
  $('[data-av-media-close]').addEventListener('click', () => closeDialog($('[data-av-media-modal]')));
  $('[data-av-media-prev]').addEventListener('click',()=>showMedia(mediaIndex-1));
  $('[data-av-media-next]').addEventListener('click',()=>showMedia(mediaIndex+1));
  $('[data-av-media-modal]').addEventListener('keydown',event=>{
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();showMedia(mediaIndex+(event.key==='ArrowRight'?1:-1));}
  });
  $('[data-av-gallery-next]').addEventListener('click',()=>{
    const gallery=$('[data-av-review-gallery]');
    const end=gallery.scrollLeft+gallery.clientWidth>=gallery.scrollWidth-2;
    gallery.scrollTo({left:end?0:gallery.scrollLeft+gallery.clientWidth*.8,behavior:motion});
  });
  function communityCount(){const step=community.children[1].offsetLeft-community.children[0].offsetLeft, first=Math.min(community.children.length,Math.round(community.scrollLeft/step)+1), visible=Math.max(1,Math.round(community.clientWidth/step)), last=Math.min(community.children.length,first+visible-1); $('[data-av-community-count]').textContent=(first===last?first:first+'–'+last)+' / '+community.children.length;}
  community.addEventListener('scroll',communityCount,{passive:true});
  window.addEventListener('resize',communityCount,{passive:true});
  communityCount();
  const timelineObserver = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('av-reached',entry.isIntersecting)),{rootMargin:'-5% 0px -20% 0px',threshold:0.1});
  $$('.av-timeline article').forEach(article=>timelineObserver.observe(article));
  onScroll(); showBenefit(0); updateReviews();
})();
